import { render, staticRenderFns } from "./PaymentAtlasModal.vue?vue&type=template&id=db6b04ea&scoped=true&"
import script from "./PaymentAtlasModal.vue?vue&type=script&lang=js&"
export * from "./PaymentAtlasModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAtlasModal.vue?vue&type=style&index=0&id=db6b04ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6b04ea",
  null
  
)

export default component.exports